import './Spinner.css';

import React, { type FC } from 'react';

interface SpinnerProps {
  spinnerText?: string
}

export const Spinner: FC<SpinnerProps> = ({ spinnerText }) => (
  <div className="spinner-container">
    <div className="spinner"></div>
    {
      spinnerText !== undefined
        ? <div className="spinner-text">{spinnerText}</div>
        : null
    }
  </div>
);
